import { render, staticRenderFns } from "./RuiShiLiKeJiShiChangTuBiao.vue?vue&type=template&id=3a70a576&scoped=true&"
import script from "./RuiShiLiKeJiShiChangTuBiao.vue?vue&type=script&lang=js&"
export * from "./RuiShiLiKeJiShiChangTuBiao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a70a576",
  null
  
)

export default component.exports